module.exports = __webpack_public_path__ + "static/media/capstone_permissions.f528e8d6.yaml";